import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HardwareScanService } from '../../modules/hardware-scan/services/hardware-scan.service';
import { CommonService } from '../common/common.service';
import { ConfigService } from '../config/config.service';

@Injectable({
	providedIn: 'root',
})
export class HardwareScanGuard implements CanActivate {
	constructor(
		private configService: ConfigService,
		private hardwareScanService: HardwareScanService,
		public commonService: CommonService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {
		return this.hardwareScanService.isAvailable().then((available) => {
			if (available) {
				return true;
			} else {
				return this.commonService.isFirstPageLoaded()
					? false
					: this.configService.defaultRoute;
			}
		});
	}

	canActivateChild(
		childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {
		return this.canActivate(childRoute, state);
	}
}
